export default {
    path: '/serviceclean',
    meta: {
        title: '预约保洁',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/serviceclean`),
}


// WEBPACK FOOTER //
// ./src/views/ServiceClean/router.js